// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"115":"f3d1f390","266":"ba3d1919","346":"8d986eff","360":"6d287977","430":"5d17dc57","938":"0ed19de8","960":"cab922b0"}[chunkId] + ".css";
};